<template>
  <div class="accordion">
    <div class="container">
      <h2 class="accordion-title" @click="open = !open">
        {{ title }}
        <caret-icon class="caret-icon" :class="{ 'open': open }" />
      </h2>

      <div class="accordion-content" v-if="open">
        <p v-if="titleStr === 'luxToPar'">{{$t('luxToParInfo')}}</p>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import caretIcon from "@/assets/icons/horti_03-right-12px.svg?inline";

export default {
  name: "Accordion",
  props: ["title", "titleStr"],
  components: { caretIcon },
  data() {
    return {
      open: false
    };
  },

  mounted() {
    // this.getUserScreenHeight(); //dont use for now
  },

  methods: {
    getUserScreenHeight() {
      const screenHeight = document.documentElement.clientHeight;
      if(screenHeight >= 1200) {
        this.open = true;
      }
    }
  }
};
</script>

<style lang="scss">
.accordion {
  margin: 0;

  .caret-icon {
    $size: 12px;
    width: $size;
    height: $size;
    top: calc(50% - #{$size / 2});
    position: absolute;
    right: 0;
    transform: rotate(-90deg);

    &.open {
      transform: rotate(90deg);
    }
  }

  .accordion-title {
    padding: 25px 0;

    font-size: 17px;
    font-weight: 700;
    margin: 0;
    color: $purple-700;
    position: relative;
    padding-right: 50px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .container {
    .accordion-content {
      max-width: 700px;
      padding: 0 0 20px;
      animation: fade-down-text 0.3s ease-out;
    }
  }

  &:nth-child(2n + 1) {
    background-color: $purple-100;
  }

  @keyframes fade-down-text {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
</style>
